import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { getBarToneBackground } from '@shared/components/slot-bar/slot-bar.util';
import { IStatusLegendItem } from './status-legend.interface';

@Component({
  imports: [TranslateModule],
  selector: 'app-status-legend',
  templateUrl: './status-legend.component.html',
})
export class StatusLegendComponent {
  public readonly items = input.required<IStatusLegendItem[]>();
  public readonly footnote = input<string | null>(null);

  public readonly getBarToneBackground = getBarToneBackground;
}
